<template>
  <section v-if="message">

    <div class="d-flex">
      <div style="width: 12rem;" class="ml-0 pl-0">
          <h4 class="m-0 p-0 mt-2 mb-1  link-header">{{ $t("FROM") }}</h4>
          {{ FormatDateTime(message.settings.open_from_date) }}
      </div>
      <div style="width: 12rem;" class="ml-0 pl-0">
            <h4 class="m-0 p-0 mt-2 mb-1  link-header">{{ $t("TO") }}</h4>
            {{ FormatDateTime(message.settings.open_to_date) }}
      </div>
    </div>
    
      <hr class="pb-0 mb-0 mt-2" v-if="attachments.length != 0" />

    <div class="mt-2" v-if="attachments.length != 0">
      <span
        v-for="(item, index) in attachments"
        :key="index"
        class="ms-fontSize-12"
      >
        <Attachment :item="item" :index="index"
        :message_uuid="message.message_uuid"
        :user_uuid="user_uuid"
        :functionbox_uuid="functionbox_uuid"></Attachment>
      </span>
    </div>
    
      <h4 class="m-0 p-0 mt-2 mb-1  link-header">{{ $t("DESCRIPTION") }}</h4>
      
    <BodyText :body="message.external_text"></BodyText>

      <hr class="pb-0 mb-0 mt-2" />

    <div v-if="isFinished">
      <b-button disabled>{{ $t("MEETINGS.EXPIRED") }}</b-button>
    </div>
    <div v-if="!isFinished">
      <a :href="join_url" class="mt-4 btn btn-fill btn-primary text-white">{{
        $t("SECURELINK.TEAMS.JOIN_MEETING")
      }}</a>
    </div>

    </section>
</template>
<script>
import Attachment from "@/components/View/Attachment";
import BodyText from "@/components/View/BodyText";
export default {
  name: "MessageInformation",
  props: ["message","user_uuid", "functionbox_uuid"],
  components: {
    Attachment,
    BodyText,
  },
  data() {
    return {
    };
  },
  methods: {
  },
  computed: {
    isFinished() {
      return this.current > this.expire;
    },
    expire() {
      let date = new Date(this.message.settings.open_to_date);
      return date;
    },
    current() {
      let date = new Date();
      return date;
    },
    attachments() {
      return this.message.attachments.filter((attachment) => {
        return attachment.name != "join_url.txt";
      });
    },
    join_url() {
      let join_attachment = this.message.attachments.filter((attachment) => {
        return attachment.name == "join_url.txt";
      });
      if (join_attachment.length == 1) {
        return join_attachment[0].content;
      } else {
        return null;
      }
    },
    createdTime() {
      return this.FormatDateTime(this.message.created_date);
    },
    createdName() {
      return (
        this.message.creator.name +
        ", " +
        this.message.creator.organisation_name
      );
    },
  },
  watch: {},
  mounted: function() {},
};
</script>
<style></style>
